ReportOptionsController.$inject = [];
function ReportOptionsController() {
}

angular.module("tromanWeb").component("ergoReportOptions", {
    template: require('./reportOptions.html'),
    bindings: {
        args: '<',
        enable: '<'
    },
    controller: ReportOptionsController
});
